// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  ACCOUNT: '/account',
  // System 섹션
  MONITORING: '/monitoring',
  BROADCAST: '/broadcast',
  INTERACTIVE: '/interactive',
  // Health&Lifecare 섹션
  HEALTH: '/health',
  LIFECARE: '/lifecare',
  // management 섹션
  ISSUE: '/issue',
  USAGE_STATUS: '/usage-status',
  SERVICE_OPERATION: '/service-operation',
  INTEGRATION: '/integration',
  VIDEO_CALL: '/video-call',
  CONVENIENCE: '/convenience',
  NOTICE: '/notice',
  USER: '/user',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/sign-in`,
      signUp: `${ROOTS.AUTH}/sign-up`,
    },
  },
  // MONITORING
  monitoring: {
    group: {
      root: `${ROOTS.MONITORING}`,
      dashboard: `${ROOTS.MONITORING}/dashboard`,
      dashboard1: `${ROOTS.MONITORING}/dashboard/1`,
      dashboard2: `${ROOTS.MONITORING}/dashboard/2`,
      settop: `${ROOTS.MONITORING}/settop`,
      center: `${ROOTS.MONITORING}/center-usage`,
      helpdesk: `${ROOTS.MONITORING}/helpdesk`,
      helpdesk_detail: (id: string | number) => `${ROOTS.MONITORING}/helpdesk/${id}/`,
      center_detail: (id: string) => `${ROOTS.MONITORING}/center-usage/${id}/`,
      system_usage: `${ROOTS.MONITORING}/system-usage`,
      usage: `${ROOTS.MONITORING}/usage`,
    },
  },
  // NOTICE
  notice: {
    group: {
      root: `${ROOTS.NOTICE}`,
      template: `${ROOTS.NOTICE}/template`,
      template_post: `${ROOTS.NOTICE}/template/register`,
      template_detail: (id: string) => `${ROOTS.NOTICE}/template/${id}/`,
      history: `${ROOTS.NOTICE}/history`,
      history_detail: (id: string) => `${ROOTS.NOTICE}/history/${id}/`,
      send_notice: `${ROOTS.NOTICE}/send-notice`,
      receive_notice: `${ROOTS.NOTICE}/receive-notice`,
      survey: `${ROOTS.NOTICE}/survey`,
      survey_create: `${ROOTS.NOTICE}/survey/create`,
      survey_edit: (id: string | number) => `${ROOTS.NOTICE}/survey/edit/${id}`,
      survey_view: (id: string | number) => `${ROOTS.NOTICE}/survey/view/${id}`,
      survey_statistics: (id: string | number) => `${ROOTS.NOTICE}/survey/statistics/${id}`,
    },
  },
  // BROADCAST
  broadcast: {
    group: {
      root: `${ROOTS.BROADCAST}`,
      connection: `${ROOTS.BROADCAST}/connection-settings`,
      contents: `${ROOTS.BROADCAST}/contents`,
      center_monitoring: `${ROOTS.BROADCAST}/center-broadcast`,
      auto_recovery: `${ROOTS.BROADCAST}/recovery`,
      center_monitoring_detail: (id: number) => `${ROOTS.BROADCAST}/center-broadcast/${id}/`,
      contents_detail: (id: number) => `${ROOTS.BROADCAST}/contents/${id}/`,
      monitoring: `${ROOTS.BROADCAST}/monitoring`,
      viewing_time_stats: `${ROOTS.BROADCAST}/viewing-time-stats`,
    },
    schedule: {
      root: `${ROOTS.BROADCAST}/schedule`,
      linked: `${ROOTS.BROADCAST}/schedule/linked`,
      linked_week: (serverId: number | string | undefined, week: number | string | undefined) =>
        `${ROOTS.BROADCAST}/schedule/linked/${serverId}/${week}`,
    },
  },
  // INTERACTIVE (양방향 화상시스템)
  interactive: {
    group: {
      root: `${ROOTS.INTERACTIVE}`,
      settop: `${ROOTS.INTERACTIVE}/settop`,
      usage: `${ROOTS.INTERACTIVE}/usage`,
      video_call: `${ROOTS.INTERACTIVE}/video-call`,
      video_call_detail: (id: string | number) => `${ROOTS.INTERACTIVE}/video-call/${id}`,
      integration: `${ROOTS.INTERACTIVE}/integration`,
      bus: `${ROOTS.INTERACTIVE}/bus`,
    },
  },
  // USAGE STATUS (이용 현황 관리)
  usage_status: {
    group: {
      root: `${ROOTS.USAGE_STATUS}`,
      center: `${ROOTS.USAGE_STATUS}/center`,
      center_detail: (id: string) => `${ROOTS.USAGE_STATUS}/center/${id}/`,
      system: `${ROOTS.USAGE_STATUS}/system`,
      issue_stats: `${ROOTS.USAGE_STATUS}/issue-stats`,
      linked_broadcast_viewing: `${ROOTS.USAGE_STATUS}/linked-broadcast-viewing`,
    },
  },
  // SERVICE OPERATION (서비스 운영 관리)
  service_operation: {
    group: {
      root: `${ROOTS.SERVICE_OPERATION}`,
      helpdesk: `${ROOTS.SERVICE_OPERATION}/helpdesk`,
      helpdesk_detail: (id: string | number) => `${ROOTS.SERVICE_OPERATION}/helpdesk/${id}/`,
      issue: `${ROOTS.SERVICE_OPERATION}/issue`,
      scenario: `${ROOTS.SERVICE_OPERATION}/scenario`,
      integrated_log: `${ROOTS.SERVICE_OPERATION}/integrated-log`,
      account_log: `${ROOTS.SERVICE_OPERATION}/account-log`,
      account: `${ROOTS.SERVICE_OPERATION}/account`,
      account_detail: (id: string | number) => `${ROOTS.SERVICE_OPERATION}/account/${id}`,
    },
  },
  // USER MANAGEMENT (사용자 관리)
  management: {
    group: {
      root: `${ROOTS.USER}`,
      center_account: `${ROOTS.USER}/center-account`,
      account: `${ROOTS.USER}/account`,
      authority: `${ROOTS.USER}/authority`,
      integration_approval: `${ROOTS.INTEGRATION}`,
    },
  },
  // CONVENIENCE
  convenience: {
    group: {
      root: `${ROOTS.CONVENIENCE}`,
      bus: `${ROOTS.CONVENIENCE}/bus`,
      restaurant: `${ROOTS.CONVENIENCE}/restaurant`,
    },
  },
  // ISSUE
  issue: {
    group: {
      root: `${ROOTS.ISSUE}`,
      scenario: `${ROOTS.ISSUE}/scenario`,
      usage: `${ROOTS.ISSUE}/usage-statistics`,
      admin: `${ROOTS.ISSUE}/admin-log`,
      integrated_log: `${ROOTS.ISSUE}/integrated-log`,
      video_call: `${ROOTS.VIDEO_CALL}`,
    },
  },
  // HEALTH
  health: {
    group: {
      root: `${ROOTS.HEALTH}`,
      usage: `${ROOTS.HEALTH}/usage`,
      usage_log: `${ROOTS.HEALTH}/usage-log`,
      usage_log_detail: (id: string | number) => `${ROOTS.HEALTH}/usage-log/${id}`,
      promotional_material: `${ROOTS.HEALTH}/promotional-material`,
    },
  },
  // LIFECARE
  lifecare: {
    group: {
      root: `${ROOTS.LIFECARE}`,
      usage: `${ROOTS.LIFECARE}/usage`,
      competition: `${ROOTS.LIFECARE}/competition`,
      competition_detail: (id: string | number) => `${ROOTS.LIFECARE}/competition/${id}`,
      course: `${ROOTS.LIFECARE}/course`,
      course_detail: (id: string | number) => `${ROOTS.LIFECARE}/course/${id}`,
      smart_table: `${ROOTS.LIFECARE}/smart-table`,
      smart_table_detail: (id: string | number) => `${ROOTS.LIFECARE}/smart-table/${id}`,
    },
  },
  // RESTAURANT (편의기능 관리 하위)
  restaurant: {
    root: `${ROOTS.CONVENIENCE}/restaurant`,
    list: `${ROOTS.CONVENIENCE}/restaurant`,
  },
  // SURVEY (공지사항 하위)
  survey: {
    root: `${ROOTS.NOTICE}/survey`,
    create: `${ROOTS.NOTICE}/survey/create`,
    edit: (id: string | number) => `${ROOTS.NOTICE}/survey/edit/${id}`,
    statistics: (id: string | number) => `${ROOTS.NOTICE}/survey/statistics/${id}`,
  },
  // ACCOUNT (내 계정)
  account: {
    root: `${ROOTS.ACCOUNT}`,
    passwordChange: `${ROOTS.ACCOUNT}/password`,
    profileEdit: `${ROOTS.ACCOUNT}/profile`,
  },
};
